<h2>Din behörighetsgivande examen</h2>
<p>En behörighetsgivande examen är en examen som är avsedd för undervisning i förskolan, fritidshemmet, grundskolan 
    eller gymnasieskolan.</p>
<p>
    Din behörighetsgivande examen är grunden för din legitimation. Du behöver därför inte ange vilka ämnen eller
    skolformer som ingår i din examen.
</p>
<p>
    Ange från vilket lärosäte du tagit din behörighetsgivande examen och vilket år den är utfärdad. Om du har två
    behörighetsgivande examina klickar du i kryssrutan "Jag har två behörighetsgivande examina" och fyller i
    information om din andra examen också.
</p>

<ng-container *ngIf="universities$ | async as universities; else loading">
    <app-examina *ngIf="first && universities" [examinaGroup]="first" [universities]="universities"></app-examina>
</ng-container>

<app-form-group>
    <app-checkbox [control]="hasSecond">Jag har två behörighetsgivande examina</app-checkbox>
</app-form-group>

<ng-container *ngIf="universities$ | async as universities">
    <app-examina *ngIf="second && universities" [examinaGroup]="second" [universities]="universities"></app-examina>
</ng-container>

<label class="text-standard" for="payment-info">Om betalning</label>
<div id="payment-info">
    <p *ngIf="!payment">Baserat på de uppgifter som du har lämnat behöver Skolverket granska din examen innan vi kan
        besluta om du ska betala en ansökningsavgift.</p>
    <p *ngIf="payment">Baserat på de uppgifter som du har lämnat ska du betala en ansökningsavgift. Observera att du
        inte ska betala nu. Du kommer att få mer information om hur du betalar i samband med att din ansökan
        registreras.</p>
    <p *ngIf="payment"><b>Ansökningsavgiften är {{payment}} kr</b></p>
</div>

<ng-template #loading>
    <div class="spinner-container">
        <mat-spinner diameter="102"></mat-spinner>
    </div>
</ng-template>